<template>
    <div class="unbind">
          <div class="con1">
                <van-field v-model="imei" type="text" label="" placeholder="输入设备IMEI序列号">
                </van-field>
                <p class="gray font14">设备开机，手动输入设备IEMI序列号</p>
                <div class="btn">  
                    <div class="btn-primary " @click='handleClick'>确定</div>
                </div> 
          </div>
           
        <p class="logoutBtn" v-if="bindType==1" @click="gotoUrl('routePage', {pageType: 'DO_LOGOUT'})">退出登录</p>   
      
    </div>
</template>
<script>
   import {binding,verifyAvailabilityByImei} from '@/api/api.mine.js';
    export default {
        data() {
            return {
                active:1,
                tabs:[{value:1,label:'扫码绑定'},{value:2,label:'手动绑定'}],
                imei:'', 
                bindType:this.$route.query.bindType,//默认子女去绑定 1 家长登录无子女 2 添加子女 
            }
        },
        methods:{
            //手机号验证
            checkData(){
                let str=this.pubMethod.checkPhone(this.phone);
                if(this.phone&&!str)
                this.$toast('请输入正确手机号码');
            },
            hide(){
               this.active=1;
            },
            handleClick(){
                // if(checkPwd(this.phone)){
                    if(this.imei == ""){
                        this.$toast('请输入设备IMEI序列号')
                    }else{
                        if(this.bindType){//无子女
                           verifyAvailabilityByImei({imei:this.imei,}).then(data=>{
                               if(data.result){
                                   this.gotoUrl('bindChildren',{imei:this.imei});
                               }
                           })
                        }else{
                             binding({
                                phone:this.phone,
                                imei:this.imei,
                                studentId:this.loginUser.studentId
                             }).then(data=>{
                                // this.loading=false;
                                if(data.code=='00000'){
                                    this.$toast('绑定成功');
                                    this.$router.replace({name:'bind'});
                                }
                             })
                        }
                       
                    }

             
            },
        }
    }
</script>
<style lang="scss" >
    .unbind{
        height:100%;
        font-size: .18rem;
       .imgs{
        width: 1.2rem;
        height: 1.2rem;
       }
       
       .logoutBtn{
           position:fixed;
           bottom: .48rem;
           width: 100%;
           text-align: center;
           font-size:.16rem;
           color:#0A59F7;
       }
        .con1{
            padding:.2rem .12rem;
            position: relative;
            font-size: .12rem;
            .van-cell{
                font-size: .16rem;
                border:none;
                border-radius: 8px;
                margin-bottom: .06rem;
                padding:0px .16rem;
                height:.48rem;
                line-height: .48rem;
                &::after{
                    border:none;
                }
            }
            .btn{
                margin-top: .2rem;
            }
        
        }
        
    }
</style>
